<template>
	<div class="container">
		<el-container v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
			<el-header class="header">
				<!--				<i class="el-icon-user-solid"></i>-->
				<div class="logo">
					<span>
						中控-控制台 V2.0.0
					</span>
					<el-menu mode="horizontal" router background-color="#303133" text-color="#fff"
						active-text-color="#ffd04b">
						<el-submenu index="name">
							<template slot="title"><i class="iconfont">&#xe611;</i>{{name}}</template>
							<el-menu-item :index="'/User/edit.html'">修改密码</el-menu-item>
						</el-submenu>
						<el-menu-item @click="logout"><i class="iconfont">&#xe606;</i>退出</el-menu-item>
					</el-menu>
				</div>
			</el-header>
			<el-container>
				<el-aside width="250px" :style="menuHeight" class="main-hover-color" v-if="menuLoad">
					<el-menu background-color="#606266" router text-color="#fff" active-text-color="#ffd04b">
						<template>

							<el-submenu index="a" v-auth="['admin/setting']">
								<template slot="title" v-auth="['admin/setting']">
									<i class="iconfont">&#xe618;</i>系统设置
								</template>
								<el-menu-item :index="'/Basics/brand.html'" v-auth="['admin/brand/listByPage']"><i class="iconfont">&#xe702;</i>品牌管理
								</el-menu-item>
<!--								<el-menu-item :index="'/Finance/AccountType.html'"><i class="iconfont">&#xe702;</i>账目类型-->
<!--								</el-menu-item>-->
								<el-menu-item :index="'/Settings/role.html'" v-auth="['admin/role/list']"><i class="iconfont">&#xe702;</i>角色管理
								</el-menu-item>
								<el-menu-item :index="'/Settings/index.html'" v-auth="['admin/user/users']"><i class="iconfont">&#xe702;</i>账户管理
								</el-menu-item>
								<el-menu-item :index="'/Trade/index.html'" v-auth="['admin/industry/list']"><i class="iconfont">&#xe702;</i>行业管理
								</el-menu-item>
								<el-menu-item :index="'/TradeTemplate/index.html'" v-auth="['admin/industry.template/list']"><i class="iconfont">&#xe702;</i>行业模板
								</el-menu-item>
								<el-menu-item :index="'/TradeTemplateData/index.html'" v-auth="['admin/industry.templateItem/list']"><i class="iconfont">&#xe702;</i>模板数据</el-menu-item>
								<el-menu-item :index="'/Sms/index.html'" v-auth="['admin/setting/sms']"><i class="iconfont">&#xe702;</i>短信管理
								</el-menu-item>
<!--								<el-menu-item :index="'/Pay/index.html'"><i class="iconfont">&#xe702;</i>支付配置-->
<!--								</el-menu-item>-->
								<el-menu-item :index="'/Storage/index.html'" v-auth="['admin/setting/storage']"><i class="iconfont">&#xe702;</i>存储配置
								</el-menu-item>
								<el-menu-item :index="'/Logistics/LogisticsList.html'" v-auth="['admin/setting.logistics/list']"><i class="iconfont">&#xe702;</i>物流管理</el-menu-item>
<!--								<el-menu-item :index="'/Logistics/pickUp.html'"><i class="iconfont">&#xe702;</i>自提点管理-->
<!--								</el-menu-item>-->
								<el-menu-item :index="'/Settings/expressapi.html'"><i class="iconfont">&#xe702;</i>物流查询
								</el-menu-item>
							</el-submenu>

							<el-submenu index="b" v-auth="['admin/store']">
								<template slot="title" v-auth="['admin/store']">
									<i class="iconfont">&#xe970;</i>店铺管理
								</template>
								<el-menu-item :index="'/Basics/Gold.html'" v-auth="['admin/business.storeRank/list']"><i class="iconfont">&#xe702;</i>店铺等级
								</el-menu-item>
								<el-menu-item :index="'/Shop/index.html'" v-auth="['admin/business.store/list']"><i class="iconfont">&#xe6e1;</i>店铺管理
								</el-menu-item>
							</el-submenu>
							<!-- 商家功能暂时隐藏 -->
							<el-submenu index="c">
								<template slot="title">
									<i class="iconfont">&#xe970;</i>渠道管理
								</template>
								<el-menu-item :index="'/Channel/index.html'"><i class="iconfont">&#xe6e1;</i>渠道管理
								</el-menu-item>
								<el-menu-item :index="'/Channel/stat.html'"><i class="iconfont">&#xe6e1;</i>渠道账单
								</el-menu-item>
								<el-menu-item :index="'/Credit/index.html'">
									<i class="iconfont">&#xe702;</i>额度明细
								</el-menu-item>
							</el-submenu>
							<el-submenu index="d" v-auth="['admin/supplier']">
								<template slot="title">
									<el-badge :value="count.auth_supplier_count " class="item">
										<i class="iconfont">&#xe970;</i>供应商管理
									</el-badge>
								</template>
								<el-menu-item :index="'/Supplier/index.html'" v-auth="['admin/supplier/list']">
									<el-badge :value="count.auth_supplier_count " class="item">
										<i class="iconfont">&#xe6e1;</i>供应商管理
									</el-badge>
								</el-menu-item>
							</el-submenu>

							<!-- index 是展开下拉式的标识 唯一 -->
							<el-submenu index="e" v-auth="['admin/member']">
								<template slot="title">
									<i class="iconfont">&#xe617;</i>会员管理
								</template>
								<el-menu-item :index="'/Member/MemberList.html'" v-auth="['admin/member/list']"><i class="iconfont">&#xe702;</i>会员列表
								</el-menu-item>
								<el-menu-item :index="'/Member/jifen.html'" v-auth="['admin/member.jifen/listImport']"><i class="iconfont">&#xe702;</i>积分管理
								</el-menu-item>
								<el-menu-item :index="'/Member/jifenlog.html'" v-auth="['admin/member.jifen/log']"><i class="iconfont">&#xe702;</i>积分明细
								</el-menu-item>
							</el-submenu>

							<el-submenu index="f" v-auth="['admin/product']">
								<template slot="title">
									<el-badge :value="count.auth_supplier_goods_count + count.auth_store_goods_count" class="item">
										<i class="iconfont">&#xe6e9;</i>商品管理
									</el-badge>
								</template>

								<el-menu-item :index="'/Category/index.html'" v-auth="['admin/productCategory/listTreeByPid']"><i class="iconfont">&#xe702;</i>中控-商品分类
								</el-menu-item>

								<el-menu-item :index="'/Goods/index.html'" v-auth="['admin/product1/listForStorePass']"><i class="iconfont">&#xe702;</i>供应商-商品
								</el-menu-item>
								<el-menu-item :index="'/GoodsAudit/supplierGoods.html'" v-auth="['admin/product/audit']">
									<el-badge :value="count.auth_supplier_goods_count" class="item">
										<i class="iconfont">&#xe702;</i>供应商-商品审核
									</el-badge>

								</el-menu-item>
								<el-menu-item :index="'/Goods/mrchantIndex.html'" v-auth="['admin/product1/listForStorePass']"><i class="iconfont">&#xe702;</i>店铺-商品
								</el-menu-item>
								<el-menu-item :index="'/GoodsAudit/index.html'" v-auth="['admin/product1/audit']">
									<el-badge :value="count.auth_store_goods_count" class="item">
										<i class="iconfont">&#xe702;</i>店铺-商品审核
									</el-badge>

								</el-menu-item>
							</el-submenu>

							<el-submenu index="g" v-auth="['admin/order']">
								<template slot="title">
									<el-badge :value="count.new_order_count + count.refunding_count" class="item">
										<i class="iconfont">&#xe642;</i>订单管理
									</el-badge>
								</template>
								<el-menu-item :index="'/Indent/index.html'" v-auth="['admin/order/listByPage']">
									<el-badge :value="count.new_order_count" class="item">
										<i class="iconfont">&#xe702;</i>订单汇总
									</el-badge>
								</el-menu-item>
								<el-menu-item :index="'/Indent/complete.html'" v-auth="['admin/order/completedList']"><i class="iconfont">&#xe702;</i>已完成订单
								</el-menu-item>
								<el-menu-item :index="'/Indent/unfinished.html'" v-auth="['admin/order/unfinishedList']"><i class="iconfont">&#xe702;</i>未完成订单
								</el-menu-item>
								<el-menu-item :index="'/Refund/index.html'" v-auth="['admin/order.refund/list']">
									<el-badge :value="count.refunding_count" class="item">
										<i class="iconfont">&#xe702;</i>售后管理
									</el-badge>
								</el-menu-item>
							</el-submenu>

							<el-submenu index="h" v-auth="['admin/stock']">
								<template slot="title">
									<i class="iconfont">&#xe680;</i>库存管理
								</template>
								<el-menu-item :index="'/Repertory/index.html'" v-auth="['admin/stock/listStock']"><i class="iconfont">&#xe702;</i>商品库存
								</el-menu-item>
								<el-menu-item :index="'/Repertory/in.html'" v-auth="['admin/stock/listStockIn']"><i class="iconfont">&#xe702;</i>入库查询
								</el-menu-item>
								<el-menu-item :index="'/Repertory/out.html'" v-auth="['admin/stock/listStockOu']"><i class="iconfont">&#xe702;</i>出库查询
								</el-menu-item>
							</el-submenu>

							<el-submenu index="i" v-auth="['admin/finance']">
								<template slot="title">
									<i class="iconfont">&#xe633;</i>财务管理
								</template>
								<el-menu-item :index="'/Finance/index.html'" v-auth="['admin/finance/list']"><i class="iconfont">&#xe702;</i>全部对账单
								</el-menu-item>
<!--								<el-menu-item :index="'/Finance/water.html'"><i class="iconfont">&#xe702;</i>财务流水-->
<!--								</el-menu-item>-->
<!--								<el-menu-item :index="'/Finance/statement.html'"><i class="iconfont">&#xe702;</i>订单汇总-->
<!--								</el-menu-item>-->
								<!-- <el-menu-item :index="'/Finance/generate.html'"><i class="iconfont">&#xe702;</i>生成对账单</el-menu-item> -->
								<el-menu-item :index="'/Finance/check.html'" v-auth="['admin/finance/audit']"><i class="iconfont">&#xe702;</i>审核对账单
								</el-menu-item>
								<el-menu-item :index="'/Finance/Settlement.html'" v-auth="['admin/finance/settle']"><i class="iconfont">&#xe702;</i>结算对账单
								</el-menu-item>
							</el-submenu>

						</template>
					</el-menu>
				</el-aside>
				<el-container>
					<el-main :style="mainHeight" ref="main">
						<transition :name="transitionName">
							<!--element渲染内容-->
							<router-view class="router-view" v-if="menuLoad"></router-view>
						</transition>
					</el-main>
					<el-footer height="40px">
						<!--						@copy版权所有：厦门简米科技有限公司-->
					</el-footer>
				</el-container>
			</el-container>
		</el-container>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				mainHeight: {
					height: ""
				},
				menuHeight: {
					height: "",
					"overflow-x": "hidden"
				},
				transitionName: '',
				isLoad: false,
				menu: [],
				setting: {},
				name: localStorage.login_name,
				uid: '',
				menuLoad: false,
				count: {}
			}
		},
		created() {
			window.addEventListener("resize", this.setHeight);
			this.loadMain()
			this.setHeight();
			this.loadMenu()
		},

		methods: {
			loadMain: function () {
				//获取统计信息
				this.axios.get('admin/data/count').then(res => {
					this.count = res.data.count
				}).catch((res) => {

				})
			},
			setHeight() {
				this.mainHeight.height = window.innerHeight - 100 + "px";
				this.menuHeight.height = window.innerHeight - 60 + "px";
			},
			loadMenu() {
				this.axios.get('admin/data/menus').then(res => {
					this.menuLoad = true
					this.$store.dispatch('admin/user/set', {
						user: res.data.user,
						access: res.data.menus,
					});
				}).catch(() => {
				})
			},
			logout() {
				localStorage.clear();
				this.$message.success({
					message: '退出成功',
					showClose: false
				});
				this.$router.replace({
					path: '/Login.html'
				});
			}
		},
		watch: {
			$route() {
				this.transitionName = 'el-fade-in-linear'
				// 回到订顶层
				this.$refs['main'].$el.scrollTop = 0
				this.loadMain();
			},
		}
	}
</script>
<style scoped>
	/*.main-hover-color /deep/ .el-submenu__title:hover{*/
	/*	outline: 0;*/
	/*	background-color: red !important;*/
	/*}*/
	/*.main-hover-color /deep/ .el-submenu__title:focus{*/
	/*	outline: 0;*/
	/*	background-color: red !important;*/
	/*}*/
	/*.el-menu-item:focus, .el-menu-item:hover{*/
	/*	outline: 0;*/
	/*	background-color: blue !important;*/
	/*}*/
	.el-menu-item.is-active {
		background-color: #444444 !important;
	}

	.iconfont {
		vertical-align: middle;
		margin-right: 5px;
		margin-top: -4px;
		width: 24px;
		text-align: center;
		font-size: 18px;
		color: rgb(255, 255, 255);
	}

	.main {
		min-height: 100%;
		padding: 20px;
	}

	.el-main {
		padding: 0;
	}

	.container .header {
		background: #303133;
	}

	.container .el-menu {
		height: 100%;
		border: none;
	}

	.container .logo {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.container .logo span {
		color: rgb(255, 208, 75);
		font-size: 18px;
	}

	.container .el-footer {
		background-color: #DCDFE6;
		align-items: center;
		display: flex;
	}
</style>
